import React from "react";

import * as strings from "../../strings";

import { ApiResponse, RequestError } from "../api/ApiTypes";
import { isRequestError } from "../api/ApiUtils";
import { getErrorIdentifier } from "./Utils";
import type { TextElement } from "./LocaleUtils";

export const isErrorCode = (
	error: Error | null | undefined,
	code: string,
): error is RequestError => {
	if (!error) return false;
	return parseError(error).code === code;
};

export function isBrightmileApiErrorResponse<T>(
	response: ApiResponse<T> | undefined,
): response is ApiResponse<T> & { data: T } {
	const data = response?.data as any;
	return data && data.code && data.message && data.identifier;
}

export interface ParsedErrorInfo {
	code: string;
	heading: TextElement;
	message: TextElement;
	identifier: string;
	details: any;
	warning?: boolean;
}

export const parseError = (error: Error): ParsedErrorInfo => {
	if (!error) throw new Error("Can't parse error, falsy object provided");
	let code = error.constructor?.name || "Error";
	let message = error.message;
	let identifier = getErrorIdentifier(error);
	let details = {};
	let heading: TextElement = strings.MISC_ERROR;
	let warning = false;

	if (error && isRequestError(error)) {
		if (isBrightmileApiErrorResponse<any>(error.response)) {
			code = error.response.data.code;
			message = error.response.data.message;
			identifier = error.response.data.identifier;
			details = error.response.data.details;

			if (code === "misc/rate-limit-reached") {
				warning = true;
				heading = strings.MISC_TRY_AGAIN_LATER;
			}
		}
	}

	return { heading, code, identifier, message, details, warning };
};
